import { ModelEditPage } from '@rhino-project/ui-heroui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/$owner/active/$team_season_id/lineups/$id/edit'
)({
  component: RouteComponent
});

function RouteComponent() {
  const { id: modelId } = Route.useParams();

  return <ModelEditPage model="lineup" modelId={modelId} />;
}
